import {AbstractService} from "@/services/AbstractService";
import {AbstractPageObserver} from "@/services/observer/common/AbstractPageObserver";
import {app} from "@/app";

export abstract class AbstractShopifyPageObserver extends AbstractPageObserver
{

}